/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable @typescript-eslint/indent */
import {useDispatch, useSelector} from 'react-redux'
import PlaceIcon from '@mui/icons-material/Place'
import BusinessIcon from '@mui/icons-material/Business'
import {Box, Button, Menu, MenuItem, Typography, useMediaQuery, useTheme} from '@mui/material'
import Slide from '@mui/material/Slide'
import {cpsUrl} from 'config/base'
import React, {useEffect, useState} from 'react'
import {fetchAllCarriers} from 'redux/common.slice'
import {type AppDispatch} from 'redux/store'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import helpIcon from 'assets/images/normal_help-icon_u283.svg'
import helpIconHover from 'assets/images/selected_help-icon_u283_selected.svg'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import Chevron from 'assets/images/normal_chevron-booking.svg'
import Chevron1 from 'assets/images/selected_chevron-booking.svg'
import {ENDPOINT} from 'config/path'

interface IUserDetail {
    branchStationCode: string
    branchName: string
    localStation: string
    isBranchUser: boolean
    isBranchAdmin: boolean
    isCarrierAdmin: boolean
    isCarrierUser: boolean
    carrierCode: string
}

const TopHeader = () => {
    const theme = useTheme()
    const belowMd = useMediaQuery(theme.breakpoints.down('md'))
    const dispatch = useDispatch<AppDispatch>()
    const allCarrierDetails = useSelector((state: any) => state.common.allCarriers)
    const [userCarrierName, setUserCarrierName] = useState('')

    const [isHovering, setIsHovering] = useState(false)

    const handleMouseOver = () => {
        setIsHovering(true)
    }

    const handleMouseOut = () => {
        setIsHovering(false)
    }

    const userDetails: IUserDetail = useSelector(
        (state: any) =>
            state.login.loginDetails?.securityParams || {
                branchStationCode: '',
                branchName: '',
                localStation: '',
                isBranchUser: false,
                isBranchAdmin: false,
                isCarrierAdmin: false,
                isCarrierUser: false,
                carrierCode: ''
            }
    )

    useEffect(() => {
        if (allCarrierDetails?.length === 0) void dispatch(fetchAllCarriers())
    }, [dispatch])

    useEffect(() => {
        if (allCarrierDetails.length > 0) {
            const carrier = allCarrierDetails.filter(({name}) => name === userDetails.carrierCode)
            if (carrier[0]) setUserCarrierName(carrier[0].displayName)
        }
    }, [allCarrierDetails])

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const isMenuOpen = Boolean(anchorEl)

    const handleMenuClose = () => {
        setAnchorEl(null)
    }

    const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
        window.scrollTo(0, 0)
    }
    const navigatePage = (url: string) => {
        window.location.href = `${cpsUrl}` + url
    }
    const navigatePageNewTab = (url: string) => {
        const win = window.open(`${cpsUrl}` + url, '_blank')
        if (win != null) {
            win.focus()
        }
    }

    const getCarrierUserGuide = () => {
        if (userDetails.isCarrierAdmin || userDetails.isCarrierUser) {
            if (
                userDetails.carrierCode === 'AI' ||
                userDetails.carrierCode === 'AF-KL' ||
                userDetails.carrierCode === 'SK' ||
                userDetails.carrierCode === 'UW'
            ) {
                return (
                    <MenuItem
                        className='help-content'
                        onClick={() => navigatePageNewTab('/lmsweb/docs/CPS_Carrier_Guide.pdf')}
                    >
                        <Typography>
                            Career User Guide <span className='help-content-text'>(PDF)</span>
                        </Typography>
                    </MenuItem>
                )
            }
        }
    }
    const renderMenu = !belowMd ? (
        <Menu
            id='helpMenu'
            anchorEl={anchorEl}
            anchorOrigin={{vertical: 'top', horizontal: 'right'}}
            keepMounted
            transformOrigin={{vertical: 'top', horizontal: 'right'}}
            open={isMenuOpen}
            onClose={handleMenuClose}
            sx={{zIndex: theme.zIndex.modal + 1}}
        >
            <Typography className='help-header'>
                <span>CUSTOMER SUPPORT</span>
            </Typography>
            <MenuItem className='help-content' onClick={() => navigatePage(ENDPOINT.faq)}>
                <Typography>
                    FAQs
                    <br />
                    <Typography className='help-content-text'>Get answers in our help center</Typography>
                </Typography>
            </MenuItem>
            <br />
            <MenuItem className='help-content' onClick={() => navigatePage(ENDPOINT.contactExistingCPS)}>
                <Typography>
                    Contact us
                    <br />
                    <Typography className='help-content-text'>Request help from CPS or carriers</Typography>
                </Typography>
            </MenuItem>
            <br />
            <Typography className='help-header'>
                <span>GUIDES</span>
            </Typography>
            <MenuItem className='help-content' onClick={() => navigatePageNewTab('/lmsweb/docs/CPS_User_Guide.pdf')}>
                <Typography>
                    User guide <span className='help-content-text'>(PDF)</span>
                </Typography>
            </MenuItem>
            {getCarrierUserGuide()}
            <MenuItem className='help-content' onClick={() => navigatePageNewTab('/lmsweb/docs/CPS_Customs_Guide.pdf')}>
                <Typography>
                    Customs guide <span className='help-content-text'>(PDF)</span>
                </Typography>
            </MenuItem>
            <MenuItem
                className='help-content'
                onClick={() => navigatePageNewTab('/lmsweb/docs/CPS_e-Freight_User_Guide.pdf')}
            >
                <Typography>
                    e-Freight guide <span className='help-content-text'>(PDF)</span>
                </Typography>
            </MenuItem>
        </Menu>
    ) : (
        <Box my={1}>
            <Menu
                className='ListDropdownMenu'
                anchorEl={anchorEl}
                anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                keepMounted
                transformOrigin={{vertical: 'top', horizontal: 'right'}}
                open={isMenuOpen}
                onClose={handleMenuClose}
                sx={{
                    zIndex: theme.zIndex.modal + 1,
                    '& .MuiBackdrop-root': {
                        top: '82px'
                    }
                }}
                slotProps={{paper: {className: 'paper'}}}
            >
                <Slide
                    direction='left'
                    in={isMenuOpen}
                    mountOnEnter
                    unmountOnExit
                    timeout={{enter: 700, exit: 100}}
                    easing='cubic-bezier(0.22, 1, 0.36, 1)'
                >
                    <Box>
                        <Button
                            variant='text'
                            onClick={handleMenuClose}
                            className='subMenuBtn'
                            sx={{
                                color: 'black',
                                width: '100%',
                                placeContent: 'flex-start',
                                paddingLeft: '15px'
                            }}
                            onMouseOver={handleMouseOver}
                            onMouseOut={handleMouseOut}
                        >
                            <img
                                src={isHovering ? Chevron1 : Chevron}
                                className='leftExpandMore'
                                alt='ExpandMoreIcon'
                            />
                            <Typography
                                sx={{
                                    fontSize: '16px',
                                    fontWeight: '500',
                                    textTransform: 'capitalize',
                                    paddingLeft: '5px',
                                    '&:hover': {
                                        color: '#356eab',
                                        backgroundColor: '#ffffff'
                                    }
                                }}
                            >
                                Main Menu
                            </Typography>
                        </Button>
                        <br />
                        <Box sx={{bgcolor: 'rgb(249, 252, 254)'}} className='ham-HelpMenu'>
                            <Typography sx={{fontSize: '16px', fontWeight: '500', padding: '8px'}}>
                                <span>Help</span>
                            </Typography>
                            <br />
                            <Typography className='help-header'>
                                <span>CUSTOMER SUPPORT</span>
                            </Typography>
                            <MenuItem
                                className='help-content'
                                onClick={() => navigatePage(`${ENDPOINT.basePath}${ENDPOINT.faq}`)}
                            >
                                <Typography>
                                    FAQs
                                    <br />
                                    <Typography className='help-content-text'>
                                        Get answers in our help center
                                    </Typography>
                                </Typography>
                            </MenuItem>
                            <br />
                            <MenuItem
                                className='help-content'
                                onClick={() => navigatePage(`${ENDPOINT.basePath}${ENDPOINT.contactExistingCPS}`)}
                            >
                                <Typography>
                                    Contact us
                                    <br />
                                    <Typography className='help-content-text'>
                                        Request help from CPS or carriers
                                    </Typography>
                                </Typography>
                            </MenuItem>
                            <br />
                            <Typography className='help-header'>
                                <span>GUIDES</span>
                            </Typography>
                            <MenuItem
                                className='help-content'
                                onClick={() => navigatePageNewTab('/lmsweb/docs/CPS_User_Guide.pdf')}
                            >
                                <Typography>
                                    User guide <span className='help-content-text'>(PDF)</span>
                                </Typography>
                            </MenuItem>
                            {getCarrierUserGuide()}
                            <MenuItem
                                className='help-content'
                                onClick={() => navigatePageNewTab('/lmsweb/docs/CPS_Customs_Guide.pdf')}
                            >
                                <Typography>
                                    Customs guide <span className='help-content-text'>(PDF)</span>
                                </Typography>
                            </MenuItem>
                            <MenuItem
                                className='help-content'
                                onClick={() => navigatePageNewTab('/lmsweb/docs/CPS_e-Freight_User_Guide.pdf')}
                            >
                                <Typography>
                                    e-Freight guide <span className='help-content-text'>(PDF)</span>
                                </Typography>
                            </MenuItem>
                        </Box>
                    </Box>
                </Slide>
            </Menu>
        </Box>
    )
    return !belowMd ? (
        <Box sx={{zIndex: theme.zIndex.modal + 1}} className='outer-wrapper'>
            <div id='TopHeader'>
                <div className='column4'>{/* TO ADD LANGUAGE OPTION */}</div>
                <div
                    className='column3'
                    onClick={handleProfileMenuOpen}
                    onMouseOver={handleMouseOver}
                    onMouseOut={handleMouseOut}
                >
                    <Box className='help'>
                        <img
                            src={helpIcon}
                            className={`helpIconImage ${isHovering ? 'display-hidden' : 'display-inline'}`}
                            alt='helpIconImage'
                        />
                        <img
                            src={helpIconHover}
                            className={`helpIconImage ${isHovering ? 'display-inline' : 'display-hidden'}`}
                            alt='helpIconHoverImage'
                        />
                        &nbsp;Help
                    </Box>
                </div>
                <div className={`column2 ${userDetails.isCarrierUser ? 'display-hidden' : 'display-inline'}`}>
                    <FiberManualRecordIcon className='topHeaderDotIcon' />
                    &nbsp;&nbsp;
                    <PlaceIcon className='topHeaderPlaceIcon' />
                    &nbsp;
                    {userDetails.branchStationCode} &nbsp;
                </div>
                <div className={`column1 ${userDetails.isCarrierUser ? 'display-hidden' : 'display-inline'}`}>
                    <BusinessIcon className='topHeaderBusinessIcon' />
                    &nbsp;&nbsp;
                    {userDetails.branchName}
                </div>
                <div className={`column1 ${userDetails.isCarrierUser ? 'display-inline' : 'display-hidden'}`}>
                    <BusinessIcon className='topHeaderBusinessIcon' />
                    &nbsp;&nbsp;
                    {userCarrierName} &nbsp;
                </div>
            </div>
            {renderMenu}
        </Box>
    ) : (
        <Box
            sx={{
                zIndex: theme.zIndex.modal + 1,
                bgcolor: 'rgb(249, 252, 254)',
                '& .MuiBox-root': {
                    margin: '0px'
                }
            }}
            className='hamHelpWrapper'
        >
            <Box
                className='hamHelpTitle'
                onClick={handleProfileMenuOpen}
                sx={{
                    zIndex: theme.zIndex.modal + 1,
                    fontWeight: '500',
                    fontSize: '16px',
                    color: '#2C2C2C',
                    px: 1,
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    fontFamily: '"Roboto-Medium", "Roboto Medium", "Roboto", sans-serif',
                    textAlign: 'left',
                    lineHeight: 'normal',
                    letterSpacing: '0.6px',
                    height: '65px',
                    '&:hover': {boxSizing: 'border-box', color: '#356eab', cursor: 'pointer'},
                    width: 'auto',
                    placeContent: 'flex-start',
                    paddingLeft: '20px'
                }}
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
            >
                <HelpOutlineOutlinedIcon fontSize='small' />
                &nbsp; Help
                <Box id='ExpandIcon'>
                    <img src={isHovering ? Chevron1 : Chevron} className='listExpandMore' alt='ExpandMoreIcon' />
                </Box>
            </Box>
            {renderMenu}
        </Box>
    )
}
export default TopHeader
